import React, { useState, useEffect } from "react";

//redux imports
import { useSelector, useDispatch } from "react-redux";
import { getAllInvoicesForLandlord } from "../../../../redux/slices/sliceActions";

//import resize function
import { vw, vh } from "../../../assets/reusableComponents/resizeFunction";

const RecentInvoicesTableComponent = () => {
  // redux methods
  const dispatch = useDispatch();
  const { allLandlordInvoices } = useSelector((state) => state.landlordslice);

  useEffect(() => {
    dispatch(getAllInvoicesForLandlord()).then((res) => {
      console.log("landlord invoices", res);
    });
  }, []);

  const [invoicesToDisplay, setInvoicesToDisplay] = useState([]);
  useEffect(() => {
    // Assuming allLandlordInvoices is an array of invoice objects
    if (allLandlordInvoices) {
      const formatedInvoices = allLandlordInvoices.map((invoice) => {
        console.log("each invoice", invoice.total);
        const formatDate = (dateString) => {
          const options = { day: "numeric", month: "long", year: "numeric" };
          const date = new Date(dateString);
          return date
            .toLocaleDateString("en-GB", options)
            .replace(/ /g, " ")
            .replace(/,/, "");
        };

        return {
          invoiceNumber: invoice._id,
          property: invoice.property,
          house_no: invoice.tenant?.house?.house_no,
          amount: invoice.total,
          date: formatDate(invoice.createdAt),
        };
      });
      setInvoicesToDisplay(formatedInvoices);
    }
  }, [allLandlordInvoices]);

  const styles = {
    container: {
      marginTop: vh(5),
      height: "46vh",
      width: "100%",
      borderRadius: vw(10),
      /* border: 2px solid #192A3A; */
      backgroundColor: "hsl(0, 0%, 100%)",
      boxShadow: "1px 1px 6px rgba(0, 0, 0, 0.1)",
      padding: vh(20),
    },
    title: {
      fontSize: vh(24),
      fontWeight: "bold",
      fontFamily: "Karla, sans-serif",
      color: "#192A3A",
    },
    divisionLine: {
      borderTop: "1px solid #E2E8EE",
      marginTop: vh(5),
    },
    latestInvoicesContainer: {
      display: "flex",
      flexDirection: "column",
      gap: vw(10),
      marginTop: vh(10),
    },
    individualInvoice: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: vh(10),
      borderRadius: vw(10),
      backgroundColor: "hsl(0, 0%, 98%)",
    },
    noInvoicesYet: {
      width: "100%",
      height: " 100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.title}>Latest Invoices</div>
      <div style={styles.divisionLine}></div>
      <div style={styles.latestInvoicesContainer}>
        {allLandlordInvoices.length > 0 ? (
          <>
            {invoicesToDisplay
              .filter((invoice) => invoice.amount > 0)
              .slice(0, 6)
              .map((invoice) => (
                <div
                  style={styles.individualInvoice}
                  key={invoice.invoiceNumber}
                >
                  <div style={styles.invoiceNumber}>{invoice.house_no}</div>
                  <div style={styles.invoiceAmount}>
                    {invoice.property?.name}
                  </div>
                  <div style={styles.invoiceAmount}>ksh {invoice.amount}</div>
                  <div style={styles.invoiceDate}>{invoice.date}</div>
                </div>
              ))}
          </>
        ) : (
          <div style={styles.noInvoicesYet}>No Invoices Created Yet</div>
        )}
      </div>
    </div>
  );
};

export default RecentInvoicesTableComponent;
